import {ComparativeValue} from "components/Analytics/constants";

export const formatNumber = (n: string) => String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ' ')

export const getRandomColor = () => {
  const letters = '0123456789ABCDEF';
  let color = '#';
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};

export const getComparativeValue = (value: number): ComparativeValue => {
  if (value < 0) return ComparativeValue.Less;
  if (value > 0) return ComparativeValue.More;
  return ComparativeValue.Equal;
}
